(function () {
  'use strict';

  if (!document.getElementById('infinite-scroll-styles')) {
    var style = document.createElement('style');
    style.id = 'infinite-scroll-styles';
    style.textContent = [
      '.infinite-scroll{display:block!important;width:100%;position:relative;clear:both;}',
      '.infinite-scroll__sentinel{display:block!important;height:1px!important;width:100%!important;pointer-events:none;visibility:visible!important;opacity:1!important;}',
      '.infinite-scroll__loader{display:none;justify-content:center;align-items:center;padding:28px 0;}',
      '.infinite-scroll__loader.is-visible{display:flex!important;}',
      '.infinite-scroll__spinner{width:28px;height:28px;border:2px solid rgba(0,0,0,.15);border-top-color:#b8943e;border-radius:50%;animation:infinite-scroll-spin .8s linear infinite;}',
      '@keyframes infinite-scroll-spin{to{transform:rotate(360deg);}}',
      '.infinite-scroll__end{display:none;align-items:center;justify-content:center;gap:14px;padding:24px 0 8px;font-size:13px;color:#888;letter-spacing:.08em;text-transform:uppercase;}',
      '.infinite-scroll__end::before,.infinite-scroll__end::after{content:"";flex:1;height:1px;background:rgba(0,0,0,.12);max-width:80px;}',
      '.infinite-scroll[data-finished="true"] .infinite-scroll__end{display:flex;}',
      '.infinite-scroll[data-finished="true"] .infinite-scroll__sentinel,.infinite-scroll[data-finished="true"] .infinite-scroll__loader{display:none;}'
    ].join('');
    document.head.appendChild(style);
  }

  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.observer = null;
    }

    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl || '';
      this.grid = this.getGrid();
      this.sentinel = this.querySelector('.infinite-scroll__sentinel');
      this.loader = this.querySelector('.infinite-scroll__loader');

      if (!this.grid || !this.sentinel) return;
      if (!this.nextUrl) {
        this.setAttribute('data-finished', 'true');
        return;
      }
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.loading) this.loadNext();
          });
        },
        { rootMargin: '600px 0px 600px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    getGrid() {
      var gridId = this.dataset.gridId || 'product-grid';
      return document.getElementById(gridId);
    }

    updateCounter() {
      const counterEl = document.querySelector('[data-product-count-current]');
      if (!counterEl || !this.grid) return;
      const total = this.grid.children.length;
      const exclude = this.grid.querySelectorAll('.ghc-promo-grid-card, .ml_hide_placeholder').length;
      counterEl.textContent = Math.max(0, total - exclude);
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      if (this.loader) this.loader.classList.add('is-visible');

      const urlBeingLoaded = this.nextUrl;

      try {
        const response = await fetch(urlBeingLoaded, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        this.grid = this.getGrid();
        const newGrid = doc.getElementById(this.dataset.gridId || 'product-grid');

        if (this.grid && newGrid) {
          this.grid.querySelectorAll('.ml_hide_placeholder').forEach((el) => el.remove());

          const fragment = document.createDocumentFragment();
          const children = Array.from(newGrid.children);
          children.forEach((child) => {
            if (child.classList && child.classList.contains('ml_hide_placeholder')) return;
            fragment.appendChild(child);
          });
          this.grid.appendChild(fragment);
          this.updateCounter();
        }

        const newIS = doc.querySelector('infinite-scroll');
        const newNext = (newIS && newIS.getAttribute('data-next-url')) || '';
        this.nextUrl = newNext === urlBeingLoaded ? '' : newNext;
        this.setAttribute('data-next-url', this.nextUrl);

        if (!this.nextUrl) {
          this.setAttribute('data-finished', 'true');
          if (this.observer) this.observer.disconnect();
        }
      } catch (_) {
        // Swallow fetch/parse errors silently — observer stays armed for next scroll.
      } finally {
        this.loading = false;
        if (this.loader) this.loader.classList.remove('is-visible');
      }
    }
  }

  if (!customElements.get('infinite-scroll')) {
    customElements.define('infinite-scroll', InfiniteScroll);
  }
})();
